import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

// Interceptor adds admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bbs_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const submitLead = (email, consent) =>
  api.post("/leads", { email, consent, source: "landing" }).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminLeads = (q = "") => api.get("/admin/leads", { params: { q, limit: 1000 } }).then((r) => r.data);
export const adminNewsletter = (subject, html_content, only_consented = true) =>
  api.post("/admin/newsletter", { subject, html_content, only_consented }).then((r) => r.data);

export const adminExportUrl = () => {
  // Used for direct download via fetch (Bearer token needed)
  return `${API}/admin/export`;
};
